import { render, staticRenderFns } from "./appVersion.vue?vue&type=template&id=21322384&scoped=true&"
import script from "./appVersion.vue?vue&type=script&lang=js&"
export * from "./appVersion.vue?vue&type=script&lang=js&"
import style0 from "./appVersion.vue?vue&type=style&index=0&id=21322384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21322384",
  null
  
)

export default component.exports